import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'white';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  ...props
}: ButtonProps) {
  const variantClasses: Record<string, string> = {
    primary: 'bg-[#FF1493] text-white hover:bg-[#D4117A] shadow-md',
    outline: 'border-2 border-white text-white hover:bg-white/10',
    ghost: 'bg-transparent text-white hover:bg-white/10',
    white: 'bg-white text-black hover:bg-gray-100'
  };
  const sizeClasses: Record<string, string> = {
    sm: 'px-5 py-2.5 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base font-bold'
  };
  return <button className={`${`inline-flex items-center justify-center rounded transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF1493] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 uppercase tracking-widest font-heading text-center ${variantClasses[variant]} ${sizeClasses[size]} ${className}`} font-[Poppins,_sans-serif]`} {...props} data-id="element-238" />;
}